import { render, staticRenderFns } from "./m-orm-synchronization-dialog.vue?vue&type=template&id=404e27a8&lang=pug&"
import script from "./m-orm-synchronization-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-synchronization-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-synchronization-dialog.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports